import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);



const state={
    show:""
};


const  mutations={
       setShow(state,data){
             console.log("传入状态",state)
             console.log("传入的值",data)
             state['show']=data;
             console.log("修改后的",state)
       }
}

export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js